import React from "react";
import {
  AppBar,
  Box,
  Container,
  IconButton,
  Paper,
  Toolbar,
  Typography,
} from "@mui/material";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { useCommonApi } from "../../custom-hooks/apis/use-common-api";
import { QueryKeys } from "../../global-state/react-query-keys";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Loader from "../../components/Loader";

const TermsOfUse = () => {
  const navigate = useNavigate();
  const { getTermsOfUseInfo } = useCommonApi();
  const TOPICS_ID = 6;

  const result = useQuery([QueryKeys.termsOfUse, TOPICS_ID], () =>
    getTermsOfUseInfo(TOPICS_ID)
  );

  return (
    <Box
      sx={{
        paddingX: 2,
      }}
    >
      <Paper sx={{ padding: 2 }}>
        {/* <Typography component="h1" variant="h6" align="center" marginY={1}>
          {result?.data?.details?.ext_1}
        </Typography> */}

        {result.isLoading ? (
          <Loader />
        ) : (
          <Typography
            dangerouslySetInnerHTML={{
              __html: result?.data?.details?.contents,
            }}
          ></Typography>
        )}
      </Paper>
    </Box>
  );
};

export default TermsOfUse;
